module.exports = __webpack_public_path__ + "static/media/Innovation_South_Greenland_2026_PDF.781938a7.pdf";